import { FeatureFlagName } from '@api'
import { combine } from 'effector'

import { $currentCreator } from '@/models/creators.ts'
import { $availableFeatures } from '@/models/feature-flags.ts'
import { CreatorFeatures } from '@/modules/accounts/types.ts'

export const $features = $currentCreator.map(
  (creator) => creator?.features ?? null,
)

export const $isMediaCloningEnabled = combine(
  $features,
  $availableFeatures,
  (features, flags) =>
    !!features?.includes(CreatorFeatures.media_cloning) &&
    !!flags?.includes(FeatureFlagName.CLONING_MEDIA),
)
